import { type ScopedPermissions } from '@air/api';

export const canGenerateZip = (sourceContext: ScopedPermissions | undefined) => !!sourceContext?.asset.canViewOriginal;
